import React, { useState, useEffect } from "react";
import { Select, MenuItem, Modal, Box, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { fetchAgents } from "../../../../entities/Agents/model/agents";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../../../../hooks/useAuth";

export default function TransferModal({
  open,
  onClose,
  onConfirm,
  propertyId,
  endpointType,
}) {
  const dispatch = useDispatch();
  const agents = useSelector((state) => state.agents.agents);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [loadingError, setLoadingError] = useState(null);
  const { auth } = useAuth();
  const token = auth?.access_token;

  useEffect(() => {
    if (token) {
      setLoadingData(true);
      dispatch(fetchAgents(token))
        .then(() => setLoadingData(false))
        .catch((error) => {
          setLoadingData(false);
          console.log(error);
          setLoadingError(error.message);
        });
    }
  }, [dispatch, token]);

  const handleTransfer = async () => {
    if (!selectedAgent) {
      toast.error("Пожалуйста, выберите агента");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("agent_id", selectedAgent);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/property/update_property/${endpointType}/${propertyId}`,
        {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        },
      );

      if (response.ok) {
        toast.success("Объект перенесен успешно");
        onClose();
      }
    } catch (error) {
      toast.error("Ошибка при отправке запроса");
    }
  };

  if (loadingData) {
    return (
      <div className="loadingContainer">
        <div className="loader"></div>
      </div>
    );
  }
  if (loadingError) {
    return (
      <div className="errorDataBox">
        <p>{loadingError}</p>
      </div>
    );
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: "20px" }}>
          Перенос объекта
        </Typography>
        {loadingData ? (
          <p>Загрузка агентов...</p>
        ) : (
          <>
            <Select
              value={selectedAgent}
              onChange={(e) => setSelectedAgent(e.target.value)}
              displayEmpty
              fullWidth
            >
              <MenuItem value="" disabled>
                Выберите агента
              </MenuItem>
              {agents.map((agent) => (
                <MenuItem key={agent.id} value={agent.id}>
                  {agent.name}
                </MenuItem>
              ))}
            </Select>
            <button
              onClick={handleTransfer}
              className="saveButton"
              style={{ marginTop: 20 }}
            >
              Перенести
            </button>
          </>
        )}
      </Box>
    </Modal>
  );
}
